import { External } from "components/icons/generated";
import TableCellEmpty from "ds/components/Table/Row/CellEmpty";
import TableCellLink from "ds/components/Table/Row/CellLink";
import TableCellText from "ds/components/Table/Row/CellText";
import { VcsProvider } from "types/generated";

import StackPullRequestsTableGroupCell from "../../GroupCell";
import { StackPullRequestsTablePullRequestCellProps } from "../types";

const StackPullRequestsTablePullRequestAuthorCell = ({
  item: pullRequest,
  stackProvider,
  ...cellProps
}: StackPullRequestsTablePullRequestCellProps) => {
  const { authorLogin } = pullRequest;

  return (
    <StackPullRequestsTableGroupCell item={pullRequest} {...cellProps}>
      {!authorLogin && <TableCellEmpty />}

      {!!authorLogin && stackProvider === VcsProvider.Github && (
        <TableCellLink
          variant="primary"
          target="_blank"
          endIcon={External}
          href={`https://github.com/${authorLogin}`}
        >
          {authorLogin}
        </TableCellLink>
      )}

      {!!authorLogin && stackProvider !== VcsProvider.Github && (
        <TableCellText>{authorLogin}</TableCellText>
      )}
    </StackPullRequestsTableGroupCell>
  );
};

export default StackPullRequestsTablePullRequestAuthorCell;
